import { Spinner } from '@components/Spinner'
import type React from 'react'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

interface ButtonB2BProps {
  label?: string
  onClick?: () => void
  disabled?: boolean
  color?: 'primary' | 'light' | 'disabled'
  mergeClass?: string
  children?: React.ReactNode
  buttonType?: 'button' | 'submit' | 'reset'
  loading?: boolean
}

export default function ButtonB2B({
  label,
  onClick,
  disabled,
  color = 'primary',
  mergeClass,
  children,
  buttonType = 'button',
  loading = false,
}: ButtonB2BProps): JSX.Element {
  // Translation
  const { t } = useTranslation()

  const classes = `${
    color === 'primary'
      ? 'bg-primary text-white'
      : color === 'light'
        ? 'text-primary'
        : color === 'disabled'
          ? 'text-textDisabled'
          : ''
  } ${(disabled ?? loading) ? 'opacity-50' : color === 'primary' ? 'hover:bg-primaryDark' : ''}
    px-6 py-3 h-12 rounded-[.325rem] w-full font-semibold flex items-center justify-center gap-4`

  return (
    <button
      type={buttonType === 'button' ? 'button' : 'submit'}
      onClick={onClick ?? undefined}
      disabled={disabled ?? loading}
      className={mergeClass ? twMerge(classes, mergeClass) : classes}
    >
      {/* @ts-ignore */}
      {label && <p className="text-center w-full font-bold">{t(label)}</p>}

      {children}

      {loading && <Spinner mergeClassName="text-white" />}
    </button>
  )
}
